<template>
  <nav class="navbar bg-lightest-gray flex-nowrap">
    <div
      @click="$emit('prev')"
      class="cursor-pointer flex-shrink-0"
      :class="{ invisible: hidePrevButton }"
    >
      <i class="fal fa-chevron-left pr-3"></i>
      <span class="d-none d-md-inline-block">{{
        prevButtonLabel || $t('STUDIO.LABELS.PREVIOUS_LESSON')
      }}</span>
    </div>
    <div v-if="title" class="c-charcoal text-center px-3">
      {{ title }}
    </div>
    <div
      @click="!nextButtonDisabled && $emit('next')"
      class="flex-shrink-0"
      :class="{
        invisible: hideNextButton,
        'cursor-pointer': !nextButtonDisabled,
      }"
    >
      <span class="d-none d-md-inline-block">{{
        nextButtonLabel || $t('STUDIO.LABELS.NEXT_LESSON')
      }}</span>
      <i
        class="fal fa-chevron-right pl-3"
        v-tooltip="{
          content: nextButtonLabel,
          delay: 100,
          placement: 'left',
          container: 'body',
          trigger: 'click hover',
        }"
      ></i>
    </div>
  </nav>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PrevNextBar',
  props: {
    title: String,
    hideNextButton: {
      type: Boolean,
      default: false,
    },
    hidePrevButton: {
      type: Boolean,
      default: false,
    },
    nextButtonLabel: {
      type: String,
    },
    prevButtonLabel: {
      type: String,
    },
    nextButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.cursor-pointer {
  cursor: pointer;
}
</style>
